module.exports = __webpack_public_path__ + "img/OurTeam.8d76e86b.png";